import api from "./api.ts";
import type { AxiosResponse } from "axios";
import type { User } from "../interfaces/user.interface.ts";

export async function signupUser(email: string, password: string): Promise<User> {
    const response: AxiosResponse<User> = await api.post("user/signup", { email, password });
    return response.data;
}

export async function loginUser(email: string, password: string): Promise<User> {
    const response: AxiosResponse<User> = await api.post("user/login", { email, password });
    return response.data;
}

export async function getCurrentUser(): Promise<User> {
    const response: AxiosResponse<User> = await api.get("user/me");
    return response.data;
}

export async function editProfile(email: string, password: string): Promise<User> {
    const response: AxiosResponse<User> = await api.patch("user/edit", { email, password });
    return response.data;
}

export async function logoutUser(): Promise<string> {
    const response: AxiosResponse<string> = await api.post("user/logout");
    return response.data;
}